import { styled } from '@unfold/theme';

export const SectionWrapper = styled.div`
  width: 100%;
  padding: 20px 108px;
`;
